import { useGetCurrentUser } from "api/api-hooks/user-hooks";
import { useGetProjectQuery, useGetUserSettingsQuery } from "gql/generated/types";
import { useParams } from "react-router-dom";

export default function useProjectContext() {
  const { projectId } = useParams();
  const {data: user} = useGetCurrentUser();
  const { data: userSettings } = useGetUserSettingsQuery({
    variables: { id: user?.externalId! },
    skip: !user,
  });
  const { data: project } = useGetProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });
  
  return { projectId, user, userSettings, project}
}